<template>
    <div class="toggler">
        <div class="activator" v-show="!visible">
            <slot name="activator" :onClick="toggle"/>
        </div>
        <div class="default" v-if="visible">
            <slot name="deactivator" :onHide="toggle"/>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Toggler',
        props: {
            initialEditMode: Boolean,
            readonly:        Boolean,
        },
        data () {
            return {
                visible: this.initialEditMode,
            }
        },
        methods: {
            toggle() {
                if (this.readonly) {
                    return;
                }
                if (this.initialEditMode) {
                    return;
                }
                if (this.visible) {
                    // timeout needed for select all function (next tick does not work)
                    // timeout has to be > 50ms, depends on client machine
                    // to be sure 100ms were chosen
                    setTimeout((function() {
                        this.visible = !this.visible
                    }).bind(this), 100);
                } else {
                    this.visible = !this.visible
                }
            },
        },
    }
</script>
<style>
    div.toggler > div.default > div.v-select {
        font-size: 12px;
        margin: 0;
        padding: 0;
    }
    div.toggler > div.default > div.v-select div.v-input__slot {
        margin: 0;
    }
    div.toggler > div.default > div.v-select div.v-input__slot div.v-select__slot > div.v-select__selections > div.v-select__selection {
        margin: 0;
    }
    div.toggler > div.default > div.v-select div.v-input__slot div.v-select__slot > div.v-select__selections > input {
        padding: 0;
    }
    div.toggler > div.default > div.v-select div.v-input__slot div.v-select__slot > div.v-input__append-inner {
        margin: 0;
    }
    div.toggler > div.default > div.v-select div.v-input__slot div.v-select__slot > div.v-input__append-inner > div.v-input__icon {
        height: 20px;
    }
</style>